module.exports=[
  {
    "owner": "Indorama Ventures (formerly Huntsman)",
    "tri_avg_reported_2014_2019": 45583,
    "emissions_date_range": "(2014 - 2019)",
    "tri_revision_amount": 0,
    "tri_revision_label": "",
    "epa_outreach_conducted": false,
    "estimated_revisions": false,
    "tri_facility_id": "77651TXCCHHWY36",
    "lat": "29.964661",
    "lng": "-93.9455174"
  },
  {
    "owner": "Dow",
    "tri_avg_reported_2014_2019": 19230,
    "emissions_date_range": "(2014 - 2019)",
    "tri_revision_amount": 0,
    "tri_revision_label": "",
    "epa_outreach_conducted": false,
    "estimated_revisions": false,
    "tri_facility_id": "77979NNCRBPOBOX",
    "lat": "28.5071716",
    "lng": "-96.7777164"
  },
  {
    "owner": "Midwest Sterilization",
    "tri_avg_reported_2014_2019": 15765,
    "emissions_date_range": "(2014 - 2019)",
    "tri_revision_amount": 0,
    "tri_revision_label": "",
    "epa_outreach_conducted": false,
    "estimated_revisions": false,
    "tri_facility_id": "78045MDWST121GE",
    "lat": "27.6205768",
    "lng": "-99.5060796"
  },
  {
    "owner": "BASF",
    "tri_avg_reported_2014_2019": 14997,
    "emissions_date_range": "(2014 - 2019)",
    "tri_revision_amount": 0,
    "tri_revision_label": "",
    "epa_outreach_conducted": false,
    "estimated_revisions": false,
    "tri_facility_id": "70734BSFCRRIVER",
    "lat": "30.1899516",
    "lng": "-91.0135812"
  },
  {
    "owner": "Dow",
    "tri_avg_reported_2014_2019": 11986,
    "emissions_date_range": "(2014 - 2019)",
    "tri_revision_amount": -59020,
    "tri_revision_label": "Cumulative Revisions, 2014-2017",
    "epa_outreach_conducted": false,
    "estimated_revisions": true,
    "tri_facility_id": "70057NNCRBHWY31",
    "lat": "29.9843617",
    "lng": "-90.4560991"
  },
  {
    "owner": "Eastman Chemical",
    "tri_avg_reported_2014_2019": 8934,
    "emissions_date_range": "(2014 - 2019)",
    "tri_revision_amount": -18029,
    "tri_revision_label": "Cumulative Revisions, 2014-2018",
    "epa_outreach_conducted": false,
    "estimated_revisions": false,
    "tri_facility_id": "75607TXSSTOFFHI",
    "lat": "32.4364433",
    "lng": "-94.7048254"
  },
  {
    "owner": "Shell",
    "tri_avg_reported_2014_2019": 7492,
    "emissions_date_range": "(2014 - 2019)",
    "tri_revision_amount": 0,
    "tri_revision_label": "",
    "epa_outreach_conducted": false,
    "estimated_revisions": false,
    "tri_facility_id": "70737SHLLCRIVER",
    "lat": "30.1824915",
    "lng": "-91.0653647"
  },
  {
    "owner": "Equistar",
    "tri_avg_reported_2014_2019": 7211,
    "emissions_date_range": "(2014 - 2019)",
    "tri_revision_amount": 0,
    "tri_revision_label": "",
    "epa_outreach_conducted": false,
    "estimated_revisions": false,
    "tri_facility_id": "77507QSTRC5761U",
    "lat": "29.627167",
    "lng": "-95.080194"
  },
  {
    "owner": "Sasol",
    "tri_avg_reported_2014_2019": 2397,
    "emissions_date_range": "(2014 - 2019)",
    "tri_revision_amount": -67362,
    "tri_revision_label": "Cumulative Revisions, 2014-2018",
    "epa_outreach_conducted": false,
    "estimated_revisions": false,
    "tri_facility_id": "70669VSTCHOLDSP",
    "lat": "30.2466152",
    "lng": "-93.2956038"
  },
  {
    "owner": "Celanese / Old World Industries",
    "tri_avg_reported_2014_2019": 6519,
    "emissions_date_range": "(2014 - 2019)",
    "tri_revision_amount": 0,
    "tri_revision_label": "",
    "epa_outreach_conducted": false,
    "estimated_revisions": false,
    "tri_facility_id": "77507HCHST9502B",
    "lat": "29.6187198",
    "lng": "-95.0718802"
  },
  {
    "owner": "Midwest Sterilization",
    "tri_avg_reported_2014_2019": 6368,
    "emissions_date_range": "(2014 - 2019)",
    "tri_revision_amount": 0,
    "tri_revision_label": "",
    "epa_outreach_conducted": true,
    "estimated_revisions": false,
    "tri_facility_id": "63755MDWST124LE",
    "lat": "37.37157",
    "lng": "-89.6885297"
  },
  {
    "owner": "B Braun Medical Inc",
    "tri_avg_reported_2014_2019": 5700,
    "emissions_date_range": "(2014 - 2019)",
    "tri_revision_amount": 0,
    "tri_revision_label": "",
    "epa_outreach_conducted": false,
    "estimated_revisions": false,
    "tri_facility_id": "18018BRRNM824TW",
    "lat": "40.6417814",
    "lng": "-75.4496991"
  },
  {
    "owner": "Sterilization Services of Virginia",
    "tri_avg_reported_2014_2019": 6337,
    "emissions_date_range": "(2014 - 2019)",
    "tri_revision_amount": 0,
    "tri_revision_label": "",
    "epa_outreach_conducted": false,
    "estimated_revisions": false,
    "tri_facility_id": "23231STRLZ5674E",
    "lat": "37.5033966",
    "lng": "-77.3576876"
  },
  {
    "owner": "Indorama Ventures (formerly Huntsman)",
    "tri_avg_reported_2014_2019": 5371,
    "emissions_date_range": "(2014 - 2019)",
    "tri_revision_amount": 0,
    "tri_revision_label": "",
    "epa_outreach_conducted": false,
    "estimated_revisions": false,
    "tri_facility_id": "77301TXCCHJEFFE",
    "lat": "30.3137211",
    "lng": "-95.3906731"
  },
  {
    "owner": "Baxter Healthcare",
    "tri_avg_reported_2014_2019": 4979,
    "emissions_date_range": "(2014 - 2019)",
    "tri_revision_amount": 0,
    "tri_revision_label": "",
    "epa_outreach_conducted": false,
    "estimated_revisions": false,
    "tri_facility_id": "72653BXTRH1900N",
    "lat": "36.3599627",
    "lng": "-92.3902019"
  },
  {
    "owner": "Dow",
    "tri_avg_reported_2014_2019": 3658,
    "emissions_date_range": "(2014 - 2019)",
    "tri_revision_amount": 0,
    "tri_revision_label": "",
    "epa_outreach_conducted": false,
    "estimated_revisions": false,
    "tri_facility_id": "70765THDWCHIGHW",
    "lat": "30.326992",
    "lng": "-91.2588654"
  },
  {
    "owner": "Dow",
    "tri_avg_reported_2014_2019": 2133,
    "emissions_date_range": "(2014 - 2019)",
    "tri_revision_amount": -13866,
    "tri_revision_label": "Cumulative Revisions, 2014-2018",
    "epa_outreach_conducted": false,
    "estimated_revisions": false,
    "tri_facility_id": "25112NNCRBRTE25",
    "lat": "38.3793816",
    "lng": "-81.767619"
  },
  {
    "owner": "Monument Chemical",
    "tri_avg_reported_2014_2019": 3297,
    "emissions_date_range": "(2014 - 2019)",
    "tri_revision_amount": 0,
    "tri_revision_label": "",
    "epa_outreach_conducted": false,
    "estimated_revisions": false,
    "tri_facility_id": "40108LNCRPHIGHW",
    "lat": "38.0051758",
    "lng": "-86.1243686"
  },
  {
    "owner": "Croda",
    "tri_avg_reported_2014_2019": 2787,
    "emissions_date_range": "(2014 - 2019)",
    "tri_revision_amount": 0,
    "tri_revision_label": "",
    "epa_outreach_conducted": false,
    "estimated_revisions": false,
    "tri_facility_id": "19720CMRCSCHERR",
    "lat": "39.689346",
    "lng": "-75.5454627"
  },
  {
    "owner": "Sterigenics",
    "tri_avg_reported_2014_2019": 2577,
    "emissions_date_range": "(2014 - 2016)",
    "tri_revision_amount": 0,
    "tri_revision_label": "",
    "epa_outreach_conducted": false,
    "estimated_revisions": false,
    "tri_facility_id": "88008GRFFT2400A",
    "lat": "31.8606389",
    "lng": "-106.6903598"
  },
  {
    "owner": "BCP Ingredients",
    "tri_avg_reported_2014_2019": 2269,
    "emissions_date_range": "(2014 - 2019)",
    "tri_revision_amount": -3468,
    "tri_revision_label": "Cumulative Revisions, 2017-2018",
    "epa_outreach_conducted": true,
    "estimated_revisions": false,
    "tri_facility_id": "65769SYNTXFIRST",
    "lat": "36.9636715",
    "lng": "-93.8005443"
  },
  {
    "owner": "Terumo BCT Sterilization Services",
    "tri_avg_reported_2014_2019": 2168,
    "emissions_date_range": "(2014 - 2019)",
    "tri_revision_amount": 0,
    "tri_revision_label": "",
    "epa_outreach_conducted": true,
    "estimated_revisions": false,
    "tri_facility_id": "80215CBSTR11308",
    "lat": "39.7350305",
    "lng": "-105.1230388"
  },
  {
    "owner": "Balchem",
    "tri_avg_reported_2014_2019": 2086,
    "emissions_date_range": "(2014 - 2019)",
    "tri_revision_amount": -4206,
    "tri_revision_label": "Cumulative Revisions, 2017",
    "epa_outreach_conducted": false,
    "estimated_revisions": false,
    "tri_facility_id": "70776BPRDC3830H",
    "lat": "30.2490657",
    "lng": "-91.0905748"
  },
  {
    "owner": "Evonik",
    "tri_avg_reported_2014_2019": 2625,
    "emissions_date_range": "(2014 - 2019)",
    "tri_revision_amount": 0,
    "tri_revision_label": "",
    "epa_outreach_conducted": false,
    "estimated_revisions": false,
    "tri_facility_id": "70084LCLCX430NO",
    "lat": "30.0595701",
    "lng": "-90.6173514"
  },
  {
    "owner": "Sterigenics",
    "tri_avg_reported_2014_2019": 2479,
    "emissions_date_range": "(2014 - 2016)",
    "tri_revision_amount": 0,
    "tri_revision_label": "",
    "epa_outreach_conducted": false,
    "estimated_revisions": false,
    "tri_facility_id": "84116SRXMD5725W",
    "lat": "40.778",
    "lng": "-112.025"
  },
  {
    "owner": "Solvay / Lanxess ",
    "tri_avg_reported_2014_2019": 2117,
    "emissions_date_range": "(2014 - 2019)",
    "tri_revision_amount": 0,
    "tri_revision_label": "",
    "epa_outreach_conducted": true,
    "estimated_revisions": false,
    "tri_facility_id": "29415LBRGH2151K",
    "lat": "32.8348724",
    "lng": "-79.966879"
  },
  {
    "owner": "Lyondell Chemical",
    "tri_avg_reported_2014_2019": 1866,
    "emissions_date_range": "(2014 - 2019)",
    "tri_revision_amount": 0,
    "tri_revision_label": "",
    "epa_outreach_conducted": false,
    "estimated_revisions": false,
    "tri_facility_id": "77530RCCHM2502S",
    "lat": "29.8189392",
    "lng": "-95.1328844"
  },
  {
    "owner": "Dow",
    "tri_avg_reported_2014_2019": 1574,
    "emissions_date_range": "(2014 - 2019)",
    "tri_revision_amount": 0,
    "tri_revision_label": "",
    "epa_outreach_conducted": false,
    "estimated_revisions": false,
    "tri_facility_id": "77541THDWCBUILD",
    "lat": "28.9882869",
    "lng": "-95.3912391"
  },
  {
    "owner": "Clariant",
    "tri_avg_reported_2014_2019": 1348,
    "emissions_date_range": "(2014 - 2019)",
    "tri_revision_amount": 0,
    "tri_revision_label": "",
    "epa_outreach_conducted": false,
    "estimated_revisions": false,
    "tri_facility_id": "7750WCLRNT952BA",
    "lat": "29.6228383",
    "lng": "-95.0620706"
  },
  {
    "owner": "Dow",
    "tri_avg_reported_2014_2019": 1113,
    "emissions_date_range": "(2014 - 2019)",
    "tri_revision_amount": -2251,
    "tri_revision_label": "Cumulative Revisions, 2017-2019",
    "epa_outreach_conducted": false,
    "estimated_revisions": true,
    "tri_facility_id": "25303NNCRB437MA",
    "lat": "38.3613061",
    "lng": "-81.7052995"
  },
  {
    "owner": "Becton Dickinson",
    "tri_avg_reported_2014_2019": 684,
    "emissions_date_range": "(2014 - 2019)",
    "tri_revision_amount": -21158,
    "tri_revision_label": "Cumulative Revisions, 2014-2017",
    "epa_outreach_conducted": true,
    "estimated_revisions": true,
    "tri_facility_id": "30209CRBRD8195N",
    "lat": "33.6082348",
    "lng": "-83.8417018"
  },
  {
    "owner": "BASF",
    "tri_avg_reported_2014_2019": 1217,
    "emissions_date_range": "(2014 - 2019)",
    "tri_revision_amount": 0,
    "tri_revision_label": "",
    "epa_outreach_conducted": false,
    "estimated_revisions": false,
    "tri_facility_id": "29302BSFCR3455S",
    "lat": "34.9033623",
    "lng": "-81.8861033"
  },
  {
    "owner": "Vantage Specialties",
    "tri_avg_reported_2014_2019": 1380,
    "emissions_date_range": "(2014 - 2019)",
    "tri_revision_amount": -64059,
    "tri_revision_label": "Cumulative Revisions, 2010-2018",
    "epa_outreach_conducted": false,
    "estimated_revisions": false,
    "tri_facility_id": "60031MZRCH3938P",
    "lat": "42.3829277",
    "lng": "-87.9019784"
  },
  {
    "owner": "Edwards Lifesciences Corp.",
    "tri_avg_reported_2014_2019": 1183,
    "emissions_date_range": "(2014 - 2019)",
    "tri_revision_amount": -989,
    "tri_revision_label": "Cumulative Revisions, 2017",
    "epa_outreach_conducted": false,
    "estimated_revisions": true,
    "tri_facility_id": "00610BXTRHROAD4",
    "lat": "18.2935022",
    "lng": "-67.1402299"
  },
  {
    "owner": "Eastman Chemical / Taminco",
    "tri_avg_reported_2014_2019": 188,
    "emissions_date_range": "(2014 - 2019)",
    "tri_revision_amount": -6880,
    "tri_revision_label": "Cumulative Revisions, 2014-2017",
    "epa_outreach_conducted": false,
    "estimated_revisions": false,
    "tri_facility_id": "70776RPRDCHIGHW",
    "lat": "30.25177",
    "lng": "-91.0925318"
  },
  {
    "owner": "Ashland Specialty / Hercules Inc.",
    "tri_avg_reported_2014_2019": 1068,
    "emissions_date_range": "(2014 - 2019)",
    "tri_revision_amount": 0,
    "tri_revision_label": "",
    "epa_outreach_conducted": false,
    "estimated_revisions": false,
    "tri_facility_id": "23860QLNCM1111H",
    "lat": "37.291154",
    "lng": "-77.2829525"
  },
  {
    "owner": "Ethicon",
    "tri_avg_reported_2014_2019": 1045,
    "emissions_date_range": "(2014 - 2019)",
    "tri_revision_amount": 0,
    "tri_revision_label": "",
    "epa_outreach_conducted": false,
    "estimated_revisions": false,
    "tri_facility_id": "76905THCNN3348P",
    "lat": "31.4750305",
    "lng": "-100.3924981"
  },
  {
    "owner": "Sterigenics",
    "tri_avg_reported_2014_2019": 2329,
    "emissions_date_range": "(2014 - 2016)",
    "tri_revision_amount": 0,
    "tri_revision_label": "",
    "epa_outreach_conducted": true,
    "estimated_revisions": false,
    "tri_facility_id": "30080GRFFT2973O",
    "lat": "33.8319107",
    "lng": "-84.470886"
  },
  {
    "owner": "Formosa",
    "tri_avg_reported_2014_2019": 914,
    "emissions_date_range": "(2014 - 2019)",
    "tri_revision_amount": 0,
    "tri_revision_label": "",
    "epa_outreach_conducted": false,
    "estimated_revisions": false,
    "tri_facility_id": "77978FRMSPPOBOX",
    "lat": "28.6975144",
    "lng": "-96.5449333"
  },
  {
    "owner": "Stepan Co",
    "tri_avg_reported_2014_2019": 636,
    "emissions_date_range": "(2014 - 2019)",
    "tri_revision_amount": 0,
    "tri_revision_label": "",
    "epa_outreach_conducted": false,
    "estimated_revisions": false,
    "tri_facility_id": "60421STPNCRURAL",
    "lat": "41.442",
    "lng": " -88.160"
  },
  {
    "owner": "Sterigenics",
    "tri_avg_reported_2014_2019": 758,
    "emissions_date_range": "(2014 - 2016)",
    "tri_revision_amount": 0,
    "tri_revision_label": "",
    "epa_outreach_conducted": false,
    "estimated_revisions": false,
    "tri_facility_id": "28278GRFFT10801",
    "lat": "35.138",
    "lng": " -80.983"
  },
  {
    "owner": "Becton Dickinson",
    "tri_facility_id": "30650BRDMD1211M",
    "lat": "33.572",
    "lng": " -83.463",
    "tri_revision_amount": -8405,
    "epa_outreach_conducted": false,
    "estimated_revisions": true,
    "tri_avg_reported_2014_2019": 452,
    "emissions_date_range": "(2014 - 2019)",
    "revision_label": "Cumulative Revisions, 2014-2017"
  },
  {
    "owner": "Medline Industries",
    "tri_avg_reported_2014_2019": 2961,
    "tri_revision_amount": 0,
    "tri_revision_label": "",
    "epa_outreach_conducted": true,
    "estimated_revisions": false,
    "emissions_date_range": "(2014 - 2017)",
    "tri_facility_id": "60085CSMDF1160N",
    "lat": "42.326403",
    "lng": "-87.8950197"
  }
]
